module.exports = __webpack_public_path__ + "img/approvedByTheCertificate.87cfc9c5.png";